// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  UPLOAD_ID_DIFFERENT_DATA_DESCRIPTION_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_DETAIL_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_LINK_PROPS,
  UPLOAD_ID_DIFFERENT_DATA_LOADING_PROPS,
} from './constants/upload-id-different-data.constants';
// Components
import {
  ButtonComponent,
  DetailConfirmationComponent,
  ParagraphComponent,
} from '@openbank/ziniaweb-ui-components';
import { LoadingComponent } from 'components/loading/loading.component';
// Configurations
import { getDifferentDataResumeItemsConfiguration } from './configurations/upload-id-different-data.configuration';
// Hooks
import { useDifferentDataUploadIdLandingHook } from './hooks/upload-id-different-data.hook';
// Styles
import {
  UploadIdDifferentDataViewStyled,
  UploadIdDifferentDataViewInformationStyled,
} from './upload-id-different-data.view.styled';
// Translations
import { DESCRIPTION, UPLOAD_AGAIN } from './translations/upload-id-different-data.translations';

const UploadIdDifferentDataView = (): React.JSX.Element => {
  const { handleUploadAgainDocumentsLinkClick, fetching, customerData, ...restProps } =
    useDifferentDataUploadIdLandingHook();

  return (
    <LoadingComponent
      {...UPLOAD_ID_DIFFERENT_DATA_LOADING_PROPS}
      fetching={fetching && !customerData?.fullName}
    >
      <UploadIdDifferentDataViewStyled>
        <ParagraphComponent {...UPLOAD_ID_DIFFERENT_DATA_DESCRIPTION_PROPS}>
          <FormattedMessage id={DESCRIPTION} />
        </ParagraphComponent>
        <UploadIdDifferentDataViewInformationStyled>
          <DetailConfirmationComponent
            {...UPLOAD_ID_DIFFERENT_DATA_DETAIL_PROPS}
            details={getDifferentDataResumeItemsConfiguration({ ...restProps, customerData })}
          />
          <ButtonComponent
            {...UPLOAD_ID_DIFFERENT_DATA_LINK_PROPS}
            onClick={handleUploadAgainDocumentsLinkClick}
            disabled={fetching}
          >
            <FormattedMessage id={UPLOAD_AGAIN} />
          </ButtonComponent>
        </UploadIdDifferentDataViewInformationStyled>
      </UploadIdDifferentDataViewStyled>
    </LoadingComponent>
  );
};

export { UploadIdDifferentDataView };
